// extracted by mini-css-extract-plugin
export default {"heading":"style-module__hrejq","container":"style-module__mq3uL"};